import _Fab from "@mui/material/Fab";
import _ButtonBase from "@mui/material/ButtonBase";
import _Box from "@mui/material/Box";
import _Tooltip from "@mui/material/Tooltip";
import _LayersOutlined from "@mui/icons-material/LayersOutlined";
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import React, { useState } from 'react';
import { createRoot } from 'react-dom/client';
import { Trans } from 'react-i18next';
import { styled, ThemeProvider } from 'styled-components';
import { baseLayersMap } from '../../hooks';
import { baseLayersThumbnails, defaultBaseLayers } from './layers-drawer';
const id = 'layers-control';
export class BaseLayersControl {
  constructor(options, callback) {
    this.options = options;
    this.callback = callback;
  }
  onAdd(_map) {
    this.map = _map;
    this.container = document.createElement('div');
    this.container.className = 'maplibregl-ctrl';
    const content = document.createElement('div');
    content.id = id;
    this.container.appendChild(content);
    return this.container;
  }
  init(theme, options = {}) {
    this.theme = theme;
    this.update(options);
  }
  update(options = {}, callback) {
    if (!this.theme) return;
    const {
      baseLayer,
      baseLayers,
      baseLayersPlacement
    } = this.options = {
      ...this.options,
      ...options
    };
    if (callback) this.callback = callback;
    const ele = document.getElementById(id);
    if (!ele) return;
    if (!this.root) this.root = createRoot(ele);
    this.root.render(/*#__PURE__*/React.createElement(BaseLayerControl, {
      baseLayers: baseLayers,
      baseLayersPlacement: baseLayersPlacement,
      onSelect: this.callback,
      selectedBaseLayer: baseLayer,
      theme: this.theme
    }));
  }
  onRemove() {
    this.container?.parentNode?.removeChild(this.container);
    this.map = undefined;
  }
}
function BaseLayerControl({
  theme,
  baseLayers,
  baseLayersPlacement,
  selectedBaseLayer,
  onSelect
}) {
  const [tooltipOpen, toggleTooltip] = useState(null);
  const [buttonsShowed, showButtons] = useState(false);
  return /*#__PURE__*/React.createElement(MuiThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, baseLayersPlacement === 'top-right' ? /*#__PURE__*/React.createElement(TopWrapper, null, /*#__PURE__*/React.createElement(StyledFab, {
    onClick: () => showButtons(!buttonsShowed),
    size: "medium"
  }, /*#__PURE__*/React.createElement(_LayersOutlined, {
    color: "primary"
  })), /*#__PURE__*/React.createElement(ColumnWrapper, {
    sx: {
      display: buttonsShowed ? 'flex' : 'none'
    }
  }, (baseLayers || defaultBaseLayers).map(key => /*#__PURE__*/React.createElement(_Tooltip, {
    key: key,
    onClose: () => toggleTooltip(null),
    onOpen: () => toggleTooltip(key),
    open: tooltipOpen === key,
    placement: "left",
    title: /*#__PURE__*/React.createElement(Trans, {
      i18nKey: baseLayersMap[key].labelKey
    })
  }, /*#__PURE__*/React.createElement(StyledButton, {
    className: key === selectedBaseLayer ? 'selected' : '',
    onClick: () => {
      if (key !== selectedBaseLayer) {
        toggleTooltip(null);
        onSelect(key);
      }
    }
  }, /*#__PURE__*/React.createElement(StyledBaseLayerThumbail, {
    src: baseLayersThumbnails[key]
  })))))) : /*#__PURE__*/React.createElement(Wrapper, null, (baseLayers || defaultBaseLayers).map(key => /*#__PURE__*/React.createElement(_Tooltip, {
    key: key,
    onClose: () => toggleTooltip(null),
    onOpen: () => toggleTooltip(key),
    open: tooltipOpen === key,
    placement: "top",
    title: /*#__PURE__*/React.createElement(Trans, {
      i18nKey: baseLayersMap[key].labelKey
    })
  }, /*#__PURE__*/React.createElement(StyledButton, {
    className: key === selectedBaseLayer ? 'selected' : '',
    onClick: () => {
      if (key !== selectedBaseLayer) {
        toggleTooltip(null);
        onSelect(key);
      }
    }
  }, /*#__PURE__*/React.createElement(StyledBaseLayerThumbail, {
    src: baseLayersThumbnails[key]
  })))))));
}
const TopWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-end;
`;
const Wrapper = styled.div`
  display: flex;

  > *:not(:first-child) {
    margin-left: 4px;
  }
`;
const ColumnWrapper = styled(_Box)`
  flex-direction: column;
  gap: 8px;
  background-color: white;
  padding: 8px;
  border-radius: 8px;
`;
const StyledButton = styled(_ButtonBase)`
  && {
    border: 1px solid #555;
    border-radius: 8px;
    padding: 1px;

    &.selected {
      border: 1px solid ${({
  theme
}) => theme.palette.primary.main};
    }
  }
`;
const StyledBaseLayerThumbail = styled.img`
  border-radius: 6px;
  height: 32px;
  width: 32px;
`;
const StyledFab = styled(_Fab)`
  && {
    &:not(:disabled):not(.MuiFab-primary):not(.MuiFab-secondary) {
      background-color: #fff;
    }

    &:not(:disabled):not(.MuiFab-primary):not(.MuiFab-secondary):hover {
      background-color: #d5d5d5;
    }

    &.MuiFab-primary:hover {
      background-color: ${({
  theme
}) => theme.palette.primary.dark};
    }

    &.MuiFab-secondary:hover {
      background-color: ${({
  theme
}) => theme.palette.secondary.dark};
    }
  }
`;